import React from "react";

// Import your images here (adjust paths based on your folder structure)
import MetaTitleIcon from "../../../Assets/images/home/ai-banner-img/meta-title.png";
import MetaDescriptionIcon from "../../../Assets/images/home/ai-banner-img/meta-description.png";
import MetaKeywordsIcon from "../../../Assets/images/home/ai-banner-img/meta-keywords.png";
import Slider from "react-slick";
import { Col, Container, Row } from "react-bootstrap";
import { tr } from "date-fns/locale";

const seoFeatures = [
    {
        icon: MetaTitleIcon,
        title: "Meta Title",
        description: "Engaging and keyword rich titles.",
    },
    {
        icon: MetaDescriptionIcon,
        title: "Meta Description",
        description: "SEO-friendly short product summaries to boost your click through rates.",
    },
    {
        icon: MetaKeywordsIcon,
        title: "Meta Keywords",
        description: "Relevant keywords to help your product top the search results",
    },
];
const settingsSeo = {
    dots: false,
    infinite: true,
    autoplay: true,
    arrows:false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                // infinite: true,
                // dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};

const SeoFeatures = () => {
    return (
        <section className="powered_ai_seo_section">
            <Container className="bw_custome_footer_container ">
                <Row>
                    <Col>
                        <h2 className="Power_AI_headings">
                            SEO content that your product deserves.
                        </h2>
                    </Col>
                </Row>

                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <Slider {...settingsSeo} className="powered_ai_seo_slider">
                            {seoFeatures.map((feature, index) => (
                                <div className="powered_ai_seo_slider_outer">
 <div key={index} className="flex flex-col items-center text-center">
                                    <div className="text-center">
                                        <img src={feature.icon} alt={feature.title} className="w-8 h-8" />
                                    </div>
                                    <h3 className="font-semibold mb-2">{feature.title}</h3>
                                    <p className="text-gray-600 text-sm text-center max-w-xs">
                                        {feature.description}
                                    </p>
                                </div>
                                </div>
                               
                            ))}

                        </Slider>
                    </Col>
                </Row>
            </Container>

        </section>
    );
};

export default SeoFeatures;